/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable arrow-body-style */
/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

// import StyleForm from './Form.styled';
// import FilterIcon from '../../../assets/images/filter.svg';
// import StateHelper from '../../../helpers/stateHelper';
// import { SearchLicencesContext } from '../../../containers/searchLicenses/SearchLicensesContext';

function FilterDropDown(props) {
  if (props.allowSelectAll) {
    return (
      <ReactSelect
        {...props}
        options={[props.allOption, ...props.options]}
        onChange={selected => {
          if (
            selected !== null &&
            selected.length > 0 &&
            selected[selected.length - 1].value === props.allOption.value
          ) {
            return props.onChange(props.options);
          }
          return props.onChange(selected);
        }}
      />
    );
  }

  return <ReactSelect {...props} />;
}

FilterDropDown.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

FilterDropDown.defaultProps = {
  allOption: {
    label: 'Select all',
    value: '*',
  },
};

export default FilterDropDown;
